import React, { useState } from "react";
import { Container, Span, InputContain } from "../GodMode";
import InputBox from "../../Generic/InputBox";
import Button from "../../Generic/Button";

const DisposalSystemTasks = {
	DISPOSE: "DISPOSE",
};

const DISPOSAL_SYSTEM_TASKS_CONFIG = {
	[DisposalSystemTasks.DISPOSE]: { 
		taskType: "dispose", 
		name: "Dispose Item" 
	},
};

const DisposalSystem = ({ sendTask, loadingStates }) => {
	const [qpdSlotId, setQpdSlot] = useState();
	const isDisposeLoading = loadingStates[DISPOSAL_SYSTEM_TASKS_CONFIG[DisposalSystemTasks.DISPOSE].taskType] || false;

	const handleButtonClick = async () => {
		const taskData = qpdSlotId ? { qpdSlotId } : {};
		await sendTask(DISPOSAL_SYSTEM_TASKS_CONFIG[DisposalSystemTasks.DISPOSE], taskData);
	}

	return (
		<Container>
			<Container>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						QPD Slot Id
					</Span>
					<InputBox
						onChange={(e) => {
							setQpdSlot(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleButtonClick} disabled={isDisposeLoading}>
					Dispose
				</Button>
			</Container>
		</Container>
	);
};

export default DisposalSystem;
